import styled, { css } from 'styled-components';
import { color, displaySoft, label, space, maxWidth, bp } from '../../styles/tokens';
import Sparkle from './Sparkle';
import Reveal from './Reveal';

const dark = css`
  background: ${color.ink};
  color: ${color.roseSoft};
`;

const light = css`
  background: ${color.porcelain};
  color: ${color.text};
`;

export const Band = styled.section`
  ${(p) => (p.$tone === 'dark' ? dark : light)};
  padding: ${space.section} ${space.gutter};
`;

export const Inner = styled.div`
  max-width: ${maxWidth};
  margin: 0 auto;
`;

const Head = styled.header`
  text-align: center;
  margin-bottom: clamp(40px, 6vw, 72px);

  .eyebrow {
    ${label};
    display: inline-flex;
    align-items: center;
    gap: 10px;
    color: ${(p) => (p.$tone === 'dark' ? color.rose : color.fuchsia)};
    margin-bottom: 18px;
  }

  h2 {
    ${displaySoft};
    font-size: clamp(38px, 7vw, 64px);
    color: ${(p) => (p.$tone === 'dark' ? color.white : color.ink)};

    /* The lead-in phrase sits above the name, set in italic at a smaller size —
       an echo of the two-line lockup in the logo. */
    span {
      display: block;
      font-style: italic;
      font-size: 0.52em;
      letter-spacing: 0;
      color: ${(p) => (p.$tone === 'dark' ? color.rose : color.textMute)};
      margin-bottom: 0.15em;
    }
  }

  .lede {
    max-width: 54ch;
    margin: 22px auto 0;
    font-size: clamp(15px, 1.6vw, 17px);
    font-weight: 300;
    color: ${(p) => (p.$tone === 'dark' ? color.roseSoft : color.text)};

    ${bp.md} {
      font-size: 17px;
    }
  }
`;

export function SectionHead({ tone = 'light', eyebrow, children, lede }) {
  return (
    <Reveal>
      <Head $tone={tone}>
        {eyebrow && (
          <p className="eyebrow">
            <Sparkle size={11} />
            {eyebrow}
          </p>
        )}
        <h2>{children}</h2>
        {lede && <p className="lede">{lede}</p>}
      </Head>
    </Reveal>
  );
}

export default Band;
